import { render } from "./EditorialFlair.vue?vue&type=template&id=13b4d224&scoped=true"
import script from "./EditorialFlair.vue?vue&type=script&lang=js"
export * from "./EditorialFlair.vue?vue&type=script&lang=js"

import "./EditorialFlair.vue?vue&type=style&index=0&id=13b4d224&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b4d224"]])

export default __exports__